import { VF_BUTTON_SELECTOR } from 'AppSrc/core/components/forms/form-base-components/v-f-button-selector';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import {
  r11Yes,
  r11No,
  r11Na,
} from 'AppSrc/core/components/forms/value-dependency-constants';

const fieldId = 'service_outage_required_for_regression_activity';

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;

  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_BUTTON_SELECTOR);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an answer' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = [];

const vFParams = {
  multiSelect: false,
  fieldTitle: ' Service outage required for regression activity?',
};

const riskLevelParams = {
  weight: 1,
  score: {
    [r11Yes]: 4,
    [r11No]: 1,
    [r11Na]: 1,
  },
};

const serviceOutageRequiredForRegressionActivity = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  riskLevelParams,
  fieldType: VF_BUTTON_SELECTOR,
};

export { serviceOutageRequiredForRegressionActivity };
